import { Phone } from "lucide-react";

const TopBar = () => {
  return (
    <header className="bg-background border-b border-border">
      <div className="container mx-auto flex items-center justify-between py-3 px-4">
        {/* Logo + tagline */}
        <a href="/" className="flex items-center gap-4">
          <img
            src="/acg-logo.webp"
            alt="ACG Southern Highlands — Home page"
            className="h-12 w-auto"
            width={160}
            height={48}
          />
          <span className="hidden md:inline text-sm font-semibold text-foreground">
            Southern Highlands Heating & Cooling Specialists.
          </span>
        </a>

        {/* Right side */}
        <div className="flex items-center gap-4">
          <nav className="hidden lg:flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#about" className="hover:text-primary transition-colors">About ACG</a>
            <a href="/areas-we-service" className="hover:text-primary transition-colors">Areas We Service</a>
            <a href="/contact-us" className="hover:text-primary transition-colors">Contact Us</a>
          </nav>
          <a href="tel:0480841485" className="hidden md:flex items-center gap-1 text-sm font-bold text-foreground">
            <Phone className="w-4 h-4" />
            0480 841 485
          </a>
          <div className="flex gap-2">
            <a
              href="/schedule-service"
              className="px-4 py-2 text-xs font-bold uppercase bg-acg-blue text-primary-foreground rounded hover:opacity-90 transition-opacity text-center leading-tight"
            >
              Schedule your<br />
              <span className="text-sm">SERVICE</span>
            </a>
            <a
              href="/schedule-quote"
              className="px-4 py-2 text-xs font-bold uppercase bg-primary text-primary-foreground rounded hover:opacity-90 transition-opacity text-center leading-tight"
            >
              Schedule your<br />
              <span className="text-sm">QUOTE</span>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
